import { render, staticRenderFns } from "./course-guides-group-list.vue?vue&type=template&id=3dcdd267"
import script from "./course-guides-group-list.vue?vue&type=script&lang=js"
export * from "./course-guides-group-list.vue?vue&type=script&lang=js"
import style0 from "./course-guides-group-list.vue?vue&type=style&index=0&id=3dcdd267&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports